module.exports = __webpack_public_path__ + "img/data-brainstorm-logo-no_slogan.daab8da2.png";